export default __webpack_public_path__ + "static/media/live-video-kanipakam0thumb@2x.de95067f.webp";